// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   MOBILE SCREENER CONTEXT BAR
   Fixed 52px bar at bottom:64px (immediately above MobileBottomNav).
   Visible on small-width viewports AND short-height landscape phones,
   when results exist on /screener. Class prefix: mscb-
   ============================================ */

@media (max-width: 768px),
       (max-height: 500px) and (orientation: landscape) {
  .mscb-root {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 64px;
    height: 52px;
    z-index: 999;
    background: rgba(11, 15, 30, 0.97);
    backdrop-filter: blur(8px);
    border-top: 0.5px solid rgba(255, 255, 255, 0.08);
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 12px;
  }

  .mscb-chip {
    flex: 1 1;
    min-width: 0;
    height: 36px;
    background: #141823;
    border: 0.5px solid rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    color: #ffffff;
    padding: 0 10px;
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    transition: background-color 0.12s ease, transform 0.08s ease;
    font-family: inherit;
    text-align: left;
    -webkit-tap-highlight-color: transparent;
  }

  .mscb-chip:active {
    background: rgba(255, 255, 255, 0.05);
    transform: scale(0.98);
  }

  .mscb-chip-icon {
    width: 14px;
    height: 14px;
    flex-shrink: 0;
    color: rgba(255, 255, 255, 0.7);
  }

  .mscb-chip-label {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.65);
    font-weight: 500;
    flex-shrink: 0;
  }

  .mscb-chip-value {
    font-size: 12px;
    color: #ffffff;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1 1;
    min-width: 0;
  }

  .mscb-chip-caret {
    width: 11px;
    height: 11px;
    flex-shrink: 0;
    color: rgba(255, 255, 255, 0.45);
  }

  /* Settings chip — slight visual emphasis since it's the access point to
     all heatmap controls. Value text is centered (no leading "label" word). */
  .mscb-chip-settings .mscb-chip-value {
    text-align: center;
    flex: 1 1;
  }
}

/* ============================================
   LANDSCAPE TIGHTENING — context bar
   Shorter bar to give the heatmap grid more vertical room. The
   .mhm-root rule in MobileScreenerHeatmap.css matches this 56px-clearance
   budget (40px bar + ~16px safe area).
   ============================================ */
@media (max-height: 500px) and (orientation: landscape) {
  .mscb-root {
    height: 40px;
    padding: 4px 10px;
    gap: 4px;
  }

  .mscb-chip {
    height: 32px;
    padding: 0 8px;
    gap: 4px;
  }

  .mscb-chip-label {
    font-size: 10px;
  }

  .mscb-chip-value {
    font-size: 11px;
  }

  .mscb-chip-icon,
  .mscb-chip-caret {
    width: 10px;
    height: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/MobileScreenerContextBar.css"],"names":[],"mappings":"AAAA;;;;;iDAKiD;;AAEjD;;EAEE;IACE,eAAe;IACf,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,kCAAkC;IAE1B,0BAA0B;IAClC,iDAAiD;IACjD,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;EACnB;;EAEA;IACE,SAAO;IACP,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,4CAA4C;IAC5C,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,6DAA6D;IAC7D,oBAAoB;IACpB,gBAAgB;IAChB,wCAAwC;EAC1C;;EAEA;IACE,qCAAqC;IACrC,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;IACd,+BAA+B;EACjC;;EAEA;IACE,eAAe;IACf,gCAAgC;IAChC,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,SAAO;IACP,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;IACd,gCAAgC;EAClC;;EAEA;8EAC4E;EAC5E;IACE,kBAAkB;IAClB,SAAO;EACT;AACF;;AAEA;;;;;iDAKiD;AACjD;EACE;IACE,YAAY;IACZ,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/* ============================================\n   MOBILE SCREENER CONTEXT BAR\n   Fixed 52px bar at bottom:64px (immediately above MobileBottomNav).\n   Visible on small-width viewports AND short-height landscape phones,\n   when results exist on /screener. Class prefix: mscb-\n   ============================================ */\n\n@media (max-width: 768px),\n       (max-height: 500px) and (orientation: landscape) {\n  .mscb-root {\n    position: fixed;\n    left: 0;\n    right: 0;\n    bottom: 64px;\n    height: 52px;\n    z-index: 999;\n    background: rgba(11, 15, 30, 0.97);\n    -webkit-backdrop-filter: blur(8px);\n            backdrop-filter: blur(8px);\n    border-top: 0.5px solid rgba(255, 255, 255, 0.08);\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 8px 12px;\n  }\n\n  .mscb-chip {\n    flex: 1;\n    min-width: 0;\n    height: 36px;\n    background: #141823;\n    border: 0.5px solid rgba(255, 255, 255, 0.1);\n    border-radius: 8px;\n    color: #ffffff;\n    padding: 0 10px;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    cursor: pointer;\n    transition: background-color 0.12s ease, transform 0.08s ease;\n    font-family: inherit;\n    text-align: left;\n    -webkit-tap-highlight-color: transparent;\n  }\n\n  .mscb-chip:active {\n    background: rgba(255, 255, 255, 0.05);\n    transform: scale(0.98);\n  }\n\n  .mscb-chip-icon {\n    width: 14px;\n    height: 14px;\n    flex-shrink: 0;\n    color: rgba(255, 255, 255, 0.7);\n  }\n\n  .mscb-chip-label {\n    font-size: 11px;\n    color: rgba(255, 255, 255, 0.65);\n    font-weight: 500;\n    flex-shrink: 0;\n  }\n\n  .mscb-chip-value {\n    font-size: 12px;\n    color: #ffffff;\n    font-weight: 500;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    flex: 1;\n    min-width: 0;\n  }\n\n  .mscb-chip-caret {\n    width: 11px;\n    height: 11px;\n    flex-shrink: 0;\n    color: rgba(255, 255, 255, 0.45);\n  }\n\n  /* Settings chip — slight visual emphasis since it's the access point to\n     all heatmap controls. Value text is centered (no leading \"label\" word). */\n  .mscb-chip-settings .mscb-chip-value {\n    text-align: center;\n    flex: 1;\n  }\n}\n\n/* ============================================\n   LANDSCAPE TIGHTENING — context bar\n   Shorter bar to give the heatmap grid more vertical room. The\n   .mhm-root rule in MobileScreenerHeatmap.css matches this 56px-clearance\n   budget (40px bar + ~16px safe area).\n   ============================================ */\n@media (max-height: 500px) and (orientation: landscape) {\n  .mscb-root {\n    height: 40px;\n    padding: 4px 10px;\n    gap: 4px;\n  }\n\n  .mscb-chip {\n    height: 32px;\n    padding: 0 8px;\n    gap: 4px;\n  }\n\n  .mscb-chip-label {\n    font-size: 10px;\n  }\n\n  .mscb-chip-value {\n    font-size: 11px;\n  }\n\n  .mscb-chip-icon,\n  .mscb-chip-caret {\n    width: 10px;\n    height: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
